// src/components/ProfileComponentCommunicationPreferences.js

import { Link } from 'react-router-dom';
import './EditProfileComponent.scss';
import CommunicationPreferences from '../profile-menu/CommunicationPreferences';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';
const ProfileComponentCommunicationPreferences = () => {
    const BackNavIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <g clip-path="url(#clip0_77225_1906)">
                <path
                    d="M12.5 27.5L0 15L12.5 2.5L14.7188 4.71875L4.4375 15L14.7188 25.2813L12.5 27.5Z"
                    fill="#2F2B43"
                />
            </g>
            <defs>
                <clipPath id="clip0_77225_1906">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );

    return (
        <div style={{ paddingBottom: '26px' }}>
            <div className="ing-edit-profile-header-main">
                <Link to={ROUTES.PROFILE}>
                    <BackNavIcon />
                </Link>
                {getText('msg_690476370b42')}
            </div>
            <div style={{ width: '80%', margin: '0 auto' }}>
                <CommunicationPreferences />
            </div>
        </div>
    );
};

export default ProfileComponentCommunicationPreferences;
